import ImageInputManager from '../../../js/components/ImageInputManager.js';

class ImageInputAdminManager extends ImageInputManager {
    init() {
        this.footer = footerTemplate;
        this.inputFile = $('input[type=file]:not([input-not-image])');
        this.renderExistedImages();
        this.hideRemoveButton();
        this.prepareFileData();
        this.onFileLoadAction();
        this.initSortable();
        this.onFileMoved();
        this.onAltTitleFieldsChanged();
    }

    hideRemoveButton() {
        $.each($('.file-preview-frame'), function (index, previewBox) {
            if (!$(previewBox).hasClass('file-preview-initial')) {
                $(previewBox).find('.kv-file-remove').remove();
            }
        });
        this.prepareFileData();
    }

    onFileMoved() {
        let self = this;
        $(".file-preview-thumbnails").on('mouseup', function () {
            setTimeout(() => {
                self.prepareFileData();
            }, 200);
        });
    }

    onFileLoadAction() {
        let self = this;
        this.inputFile.on('fileloaded', function (event, file, previewId, index, reader) {
            $("#" + previewId).find('img').attr('data-type', $(this).data('type')); // add additional params for file data send
            self.hideRemoveButton();
            self.prepareFileData();
            self.onAltTitleFieldsChanged();
        });
    }

    onAltTitleFieldsChanged() {
        let self = this;
        $('.file-thumbnail-footer').find('input').on('change', function () {
           self.prepareFileData();
        });
    }

    initSortable() {
        $('.file-preview-thumbnails').sortable();
    };
}

const footerTemplate = '<div class="file-thumbnail-footer">\n' +
    '   <div style="margin:5px 0;border: 1px solid #ccc;padding: 5px">\n' +
    ' <label style="margin-left:5px;font-size: 10px; font-weight: 400"> {caption} </label> <br />' +
    '<div class="form-group">' +
    '<label style="float:left;margin-left:5px"> alt </label> ' +
    '<input class="form-control input-sm alt" value="{alt}">' +
    '</div>' +
    '<label style="float:left;margin-left:5px"> title </label> ' +
    '<input class="form-control input-sm title" value="{title}">' +
    '   </div>\n' +
    '   {actions}\n' +
    '</div>';

export default ImageInputAdminManager;
